import React, { useEffect, useState } from 'react';
import { IAuditTrailEvent } from '../interfaces/IAuditoriaEntradaDados';
import { AuditoriaEntradaDadosService } from '../services/AuditoriaEntradaDadosService';

interface Props {
  auditFileId: number;
  nomeArquivo: string;
  onFechar: () => void;
}

const ORIGEM_LABEL: Record<IAuditTrailEvent['source'], string> = {
  USER: 'Usuário',
  SYSTEM: 'Sistema',
  API: 'API',
  PROCESS: 'Processamento',
};

const formatarData = (iso: string) => new Date(iso).toLocaleString('pt-BR');

// Épico "Central de Entrada de Dados", seções 35-41 — Trilha de Auditoria: histórico individual
// e imutável do arquivo (upload, validações, processamento, reprocessamento, exclusão etc.).
const AuditFileHistory: React.FC<Props> = ({ auditFileId, nomeArquivo, onFechar }) => {
  const [eventos, setEventos] = useState<IAuditTrailEvent[]>([]);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;
    setCarregando(true);
    AuditoriaEntradaDadosService.buscarHistorico(auditFileId)
      .then((lista) => {
        if (ativo) setEventos(lista);
      })
      .catch(() => {
        if (ativo) setEventos([]);
      })
      .finally(() => {
        if (ativo) setCarregando(false);
      });
    return () => {
      ativo = false;
    };
  }, [auditFileId]);

  return (
    <div className='audit-modal-backdrop' onClick={onFechar}>
      <div className='audit-modal audit-modal-lg' onClick={(e) => e.stopPropagation()} role='dialog' aria-modal='true'>
        <div className='audit-modal-header'>
          <div>
            <h4>Histórico do arquivo</h4>
            <p className='text-muted mb-0 fs-8'>{nomeArquivo}</p>
          </div>
          <button type='button' className='btn-close' aria-label='Fechar' onClick={onFechar} />
        </div>
        <div className='audit-modal-body'>
          {carregando ? (
            <div className='text-muted text-center py-5'>Carregando histórico...</div>
          ) : eventos.length === 0 ? (
            <div className='text-muted text-center py-5'>Nenhum evento registrado.</div>
          ) : (
            <div className='audit-trail-timeline'>
              {eventos.map((ev) => (
                <div key={ev.id} className='audit-trail-item'>
                  <div className='audit-trail-item-dot' />
                  <div className='audit-trail-item-conteudo'>
                    <div className='audit-trail-item-topo'>
                      <span className='audit-trail-item-evento'>{ev.description}</span>
                      <span className='audit-trail-item-data'>{formatarData(ev.createdAt)}</span>
                    </div>
                    <div className='audit-trail-item-meta'>
                      Origem: {ORIGEM_LABEL[ev.source]}
                      {ev.userName ? ` · ${ev.userName}` : ''}
                      {ev.newStatus ? ` · Status: ${ev.newStatus}` : ''}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuditFileHistory;
